import { ROLE } from "../../modules/auth"

export const ADM_ROLES = [
  ROLE.ROLE_ADMIN,
]

export const DEFAULT_ROLES = [
  ...ADM_ROLES,
  ROLE.ROLE_MANAGER,
]

export const CASHIER_ROLES = [
  ...DEFAULT_ROLES,
  ROLE.ROLE_SENIOR_CASHIER,
  ROLE.ROLE_CASHIER,
]